import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Navbar } from "react-bootstrap";
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

class Logout extends Component {
  logout() {
    localStorage.removeItem("session");
    localStorage.removeItem("userCollab");
    localStorage.removeItem("react-token");
    localStorage.removeItem("react-refresh-token");
    window.location.href = FRONTEND_URL;
    this.props.keycloak.logout();
  }

  render() {
    return (
      <Navbar.Text className="nav-link w-100" onClick={() => this.logout()}>
        Logout
      </Navbar.Text>
    );
  }
}

export default withRouter(Logout);
